import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { WattiActionTypes } from "./constants";

// actions
import { wattiApiResponseSuccess, wattiApiResponseError } from "./actions";

// api
import {
  getWattiTemplatesApi,
  sendWattiBroadcastApi,
} from "../../helpers/api/watti";

import { toast } from "react-toastify";

function* getWattiTemplatesSaga(): SagaIterator {
  try {
    const response = yield call(getWattiTemplatesApi);
    const data = response?.data?.data?.messageTemplates || [];
    yield put(
      wattiApiResponseSuccess(WattiActionTypes.GET_WATTI_TEMPLATES, data)
    );
  } catch (error: any) {
    let errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      error ||
      "Failed to fetch templates";

    // Check for specific technical error and replace with user friendly message
    if (
      errorMsg.includes("Route not found") &&
      errorMsg.includes("watti-templates")
    ) {
      errorMsg =
        "WhatsApp Marketing service is currently unavailable. Please contact the administrator to enable this integration.";
    }

    yield put(
      wattiApiResponseError(WattiActionTypes.GET_WATTI_TEMPLATES, errorMsg)
    );
  }
}

function* sendWattiBroadcastSaga({ payload }: any): SagaIterator {
  try {
    const response = yield call(sendWattiBroadcastApi, payload);
    yield put(
      wattiApiResponseSuccess(WattiActionTypes.SEND_WATTI_BROADCAST, {})
    );
    toast.success(response?.data?.message || "Broadcast sent successfully");
  } catch (error: any) {
    let errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      error ||
      "Failed to send broadcast";

    // Check for specific technical error and replace with user friendly message
    if (
      errorMsg.includes("Route not found") &&
      errorMsg.includes("watti-broadcast")
    ) {
      errorMsg =
        "Unable to send broadcast. The WhatsApp Marketing service is not configured correctly.";
    }

    yield put(
      wattiApiResponseError(WattiActionTypes.SEND_WATTI_BROADCAST, errorMsg)
    );
    toast.error(errorMsg);
  }
}

export function* watchGetWattiTemplates() {
  yield takeEvery(WattiActionTypes.GET_WATTI_TEMPLATES, getWattiTemplatesSaga);
}

export function* watchSendWattiBroadcast() {
  yield takeEvery(
    WattiActionTypes.SEND_WATTI_BROADCAST,
    sendWattiBroadcastSaga
  );
}

export default function* WattiSaga() {
  yield all([fork(watchGetWattiTemplates), fork(watchSendWattiBroadcast)]);
}
